import React from 'react';
import { Header } from 'iqm-framework';

const NavbarComponent = () => {
  return <Header backButton={false} title="Template" leftLogo="Conversions" />;
};

export const Navbar = NavbarComponent;
